import { render, staticRenderFns } from "./ModalAdicionarOuEditarPastas.vue?vue&type=template&id=5901b574&scoped=true"
import script from "./ModalAdicionarOuEditarPastas.vue?vue&type=script&lang=js"
export * from "./ModalAdicionarOuEditarPastas.vue?vue&type=script&lang=js"
import style0 from "./ModalAdicionarOuEditarPastas.vue?vue&type=style&index=0&id=5901b574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5901b574",
  null
  
)

export default component.exports